import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const ArrowCurvedLeftFlippedFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M16.34 13.46C16.34 11.52 14.84 9.96 12.96 9.96H8.12L12.3 14.08L11.02 15.36L4.66 9L11.02 2.64L12.3 3.92L8.12 8.04H12.96C16.02 8.04 18.34 10.4 18.34 13.46V19H16.34V13.46Z" />
    </SvgIcon>
  );
});
